import { Currency, PropsOf } from "@chef/components";
import { language } from "@chef/constants";

type CurrencyWrapperProps = Omit<PropsOf<typeof Currency>, "language">;

export const CurrencyWrapper = (props: CurrencyWrapperProps) => (
  <Currency language={language} {...props} />
);
